var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import Link from "@gcp-artifact/compass/lib/components/updated/link";
/**
 * Link replacement utility for BE error messages with markdown links
 * Converts markdown [text](url) format to React Link
 */
export var replaceLinksInErrorMessages = function (text) {
    var _a, _b;
    // Check if text contains markdown links
    var hasMarkdownLinks = /\[([^\]]*)\]\(([^)]+)\)/.test(text);
    if (!hasMarkdownLinks) {
        return text;
    }
    // Handle markdown links: [text](url)
    var parts = [];
    var lastIndex = 0;
    var markdownRegex = /\[([^\]]*)\]\(([^)]+)\)/g;
    var match;
    while ((match = markdownRegex.exec(text)) !== null) {
        // Add text before the link
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }
        // Handle edge cases for display text and URL
        var displayText = ((_a = match[1]) === null || _a === void 0 ? void 0 : _a.trim()) || match[2]; // Use URL as fallback if display text is empty
        var url = (_b = match[2]) === null || _b === void 0 ? void 0 : _b.trim();
        if (!url || !url.startsWith("http")) {
            // If invalid URL, just add the text as-is
            parts.push(match[0]);
        }
        else {
            // Add the link component
            parts.push(React.createElement(Link, {
                key: "link-".concat(match.index),
                href: url,
                target: "_blank",
                variant: "subtle-green",
                inline: true,
                children: displayText,
            }));
        }
        lastIndex = match.index + match[0].length;
    }
    // Add remaining text
    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }
    return React.createElement.apply(React, __spreadArray([React.Fragment, {}], __read(parts), false));
};
//# sourceMappingURL=data:application/json;base64,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